import { css } from 'styled-components';

export const CyberpunkSkin = css`
  background-color: #0f0f0f;
  border: 2px solid #ff00ff;
  box-shadow:
    0 0 20px #ff00ff,
    0 0 40px #00ffff;
`;

export const CyberpunkWrapperSkin = css`
  background: linear-gradient(135deg, #1a1a1a 0%, #0d0d0d 100%);
`;

export const CyberpunkLetterSkin = css<{ $isActive: boolean }>`
  color: ${props => (props.$isActive ? '#ff00ff' : '#00ffff')};
  opacity: ${props => (props.$isActive ? 1 : 0.15)};
  text-shadow: 0 0 5px #ff00ff;
`;
